/* no-mixed-spaces-and-tabs */
<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" style="margin-left:5rem 3rem" class="gutter-row">
            <a-breadcrumb>
	            <a-breadcrumb-item>
	              <router-link tag="a" :to="{ name: 'stats' }">Stats</router-link>
	            </a-breadcrumb-item>
	            <a-breadcrumb-item>{{ this.$route.meta.title }}</a-breadcrumb-item>
	        </a-breadcrumb>
          </a-col>
        </a-row>
        <template v-if="loading">
          <div class="loader-container">
            <a-spin :size="'large'" />
          </div>
        </template>
        <template>
          <a-row :style="{ marginTop: '25px', marginBottom: '25px' }" :gutter="40">
            <a-col
              :xs="{ span : 24 }"
              :md="{ span : 24 }"
              style="margin-bottom: 10px;"
              class="gutter-row"
            >
              <a-card a-card title="Open VS Click VS Bounce Report" class="Custom--Card" :loading="loadingGraph">
              	<a slot="extra">
	                <a-select v-model="graphSelection" slot="extra" @change="handleGraph">
	                  <a-select-option value="last-7-days">Last 7 Days</a-select-option>
	                  <a-select-option value="last-30-days">Last 30 Days</a-select-option>
	                  <a-select-option value="last-month">Last Month</a-select-option>
	                </a-select>
                </a>
                <open-click-bounce-graph
                		:labels="overview.data.labels"
                		:values="overview.data.dataset"
                		color="red"
                ></open-click-bounce-graph>
              </a-card>
            </a-col>
          </a-row>
          <a-row>
          	<a-card title="Open VS Click VS Bounce Details">
          		<span slot="extra">
          			<a-select v-model="detailSelection" slot="extra" @change="handleDetails">
	                  <a-select-option value="last-7-days">Last 7 Days</a-select-option>
	                  <a-select-option value="last-30-days">Last 30 Days</a-select-option>
	                  <a-select-option value="last-month">Last Month</a-select-option>
	                </a-select>
          		</span>
      				<a-table
                  :loading="loadingTable"
	            	  :pagination="false"
	            	  :style="{background: 'white'}"
	                :bordered="false"
	                :rowKey="event => event.id"
	                size="middle"
	                :colSpan="1"
	                :columns="columns"
	                :dataSource="details.data"
	                :width="'100%'"
      	      >
      	        <template slot="type" slot-scope="type">
      				    <span :style="{ color: '#1abc9c' }" v-if="type == 'opened'">Opened</span>
      				    <span :style="{ color: '#2980b9' }" v-if="type == 'clicked'">Clicked</span>
      				    <span :style="{ color: '#e67e22' }" v-if="type == 'bounced'">Bounced</span>
      				  </template>
      	      </a-table>
      	      <template v-if="details.data">
      			      <a-pagination
      			        @change="pagination"
                    :loading="loading"
      			        v-model="details.meta.current_page"
      			        :pageSize="details.meta.per_page"
      			        :defaultCurrent="1"
      			        :total="details.meta.total"
      			        :style="{justifyContent:'flex-end',display:'flex'}"
      			      />
      			 </template>
          	</a-card>
          </a-row>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
  import Sidebar from "@/components/Sidebar.vue";
  import OpenClickBounceGraph from "@/components/OpenClickBounceGraph.vue";
  import { mapGetters } from 'vuex';

  const columns = [
    { title: 'Subscriber Name', dataIndex: 'name' },
    { title: 'Email Address', dataIndex: 'email' },
    { title: 'Type', dataIndex: 'type', scopedSlots: { customRender: 'type' }},
    { title: 'Created At', dataIndex: 'created_at' }
  ];

  export default {
    data() {
      return {
        columns: columns,
        loading: false,
        loadingGraph: false,
        loadingTable: false,
        graphSelection: 'last-30-days',
        detailSelection: 'last-30-days'
      }
    },
    components: {
      Sidebar,
      OpenClickBounceGraph
    },
    computed: {
      ...mapGetters({
        overview: 'stats/openClickBounceOverview',
        details: 'stats/openClickBounceDetails',
      })
    },
    methods: {
    	async handleGraph( ) {
    		let params = { q: this.graphSelection };
    		this.loadingGraph = true;
        await this.$store.dispatch('stats/GET_OPEN_CLICK_BOUNCE_OVERVIEW', params);
        this.loadingGraph = false;
    	},
    	async handleDetails( page = 1 ) {
    		let params = { q: this.detailSelection, page: page };
    		this.loadingTable = true;
        await this.$store.dispatch('stats/GET_OPEN_CLICK_BOUNCE_DETAIL', params);
        this.loadingTable = false;
    	},
    	pagination(page) {
    		this.handleDetails(page);
    	}
    },
    created() {
    	this.handleGraph();
    	this.handleDetails();
    }
  };
</script>
